import { Tooltip as TooltipMantine } from '@mantine/core'
import styled from 'styled-components'

export const Tooltip = styled(TooltipMantine)``
